// Standard library imports
import React, { useState, useEffect } from 'react';
// Internal module imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import EicSignalLogs from './EicSignalLogs';
import { NumberParam } from 'use-query-params';
import { useQueryParamWithDefault } from '../../../../hooks';

const EICSignalIndex = ({ eicCodeOptions, cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'DK1 Signal Logs',
            component: (
                <>
                    <EicSignalLogs eicCodeOptions={eicCodeOptions} area={'DK1'} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'DK2 Signal Logs',
            component: (
                <>
                    <EicSignalLogs eicCodeOptions={eicCodeOptions} area={'DK2'} cId={cId} />
                </>
            ),
            tabId: 1,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default EICSignalIndex;
